export const strings = {
  cases: 'Davalar',
  journals: 'Dergiler',
  comments: 'Yorumlar',
  pending: 'Askıda olması',
  approved: 'Onaylı',
  rejected: 'Reddedilmiş',
};
